import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const CheckIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('CheckIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <polyline
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="20 6 9 17 4 12"
    />
  </svg>
);

export default CheckIcon;
